/* import __COLOCATED_TEMPLATE__ from './folder.hbs.js'; */
import Component from '@glimmer/component';
export default class Folder extends Component {
  get fill() {
    return this.args.fill || 'var(--core-text-10-light-mode-color)';
  }
  get fillOpacity() {
    return this.args.fillOpacity || '0.3';
  }
  get height() {
    return this.args.height ?? '24';
  }
  get width() {
    return this.args.width ?? '24';
  }
}